export enum ChartType {
  FLAG = "FLAG",
  NUMBER = "NUMBER",
  PERCENTAGE = "PERCENTAGE",
  MESSAGE = "MESSAGE"
}
